<template>
  <loginLayout>

      <div class="login-container">
        <div class="tit">Visitor Member Center</div>
        <div class="countdown-box" v-if="$store.state.reg_info.prereg_status">
          <p class="countdown-tip">Secure Your Ticket to <span>Premier Food Products </span> at {{$store.state.reg_info.id == 2 ? 'SIAL Shenzhen' : 'SIAL Shanghai'}}, only</p>
          <countdown :endTime="$store.state.reg_info.prereg_end" format="D h m"></countdown>
        </div>
        <div class="rig-wrap login-con">
            <div>Login</div>
          <div >
            <el-form
              ref="formRef"
              :model="formModel"
              :rules="formRules"
              :hide-required-asterisk="true"
              class="login-formbox"
            >
                <el-form-item prop="account">
                  <el-input
                    type="text"
                    v-model="formModel.account"
                    suffix-icon="User"
                    placeholder="Please use email for login"
                    class="form-input"
                  />
                </el-form-item>

                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="formModel.password"
                    suffix-icon="Key"
                    placeholder="Please enter your password"
                    class="form-input"
                    @keyup.enter="DoLogin"
                  />
                </el-form-item>
            </el-form>

            <div class="remember">
              <router-link class="reme-a" :to="`${$t('baseurl')}/forget`">Forgot password?</router-link>
            </div>

            <div class="submit-box">
              <el-button type="primary" class="btn-primary2" @click="DoLogin"
                >Login</el-button
              >
              <router-link :to="`${$t('baseurl')}/reg`" v-if="$store.state.reg_info.prereg_status"><el-button type="warning">Register</el-button></router-link>
          </div>

          <p class="tip"><el-text type="danger">*</el-text> This exhibition is a professional food and beverage trade show, open exclusively to industry professionals. Individuals under 18 and non-professionals over 70 are restricted to enter the venue.</p>
          </div>
        </div>
      </div>

  </loginLayout>
</template>

<script>
import showMsg from "@/utils/message";
import { reactive, toRefs, ref, unref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Cookies from "js-cookie";
import { useI18n } from "vue-i18n";
import countdown from "@/components/countdown";
import loginLayout from "./components/loginLayout.vue"
import { debounce, throttle } from "@/utils/common";

export default {
  components: {
    countdown,
    loginLayout
  },
  setup() {
    const { t } = useI18n();

    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const state = reactive({
      loading: false,
      loadingTxt: "",
      
      formModel: {
        app_lang: "en",
        type: 3,
        account: "",
        password: "",
      },
      formRules: {
        account: [{ required: true, trigger: "blur", message: "Please enter your email" }],
        password: [{ required: true, trigger: "blur", message: "Please enter your login password" }],
      },
      is_matchme: false,
    });


    if(route.query) {
      route.query.link_id && Cookies.set("link_id",route.query.link_id, { expires: 1 });
      route.query.bd_vid && Cookies.set("bd_vid",route.query.bd_vid, { expires: 1 });

      if(route.query.matchme) {
        state.is_matchme = true;
      }
    }
   
    // 重定向处理
    const redirect = ref("");
    watchEffect(() => {
      redirect.value = route.query && route.query.redirect;
    });

    // 登录
    const formRef = ref(null);
    const DoLogin = throttle(() => {
      Cookies.remove('is_matchme');

      unref(formRef).validate((valid) => {
        if (valid) {

          state.loading = true;
          state.loadingTxt = "Logging in...";

            store
              .dispatch("user/login", state.formModel)
              .then(() => {
                // 登录成功，用户跳转
                if(state.is_matchme) {
                  Cookies.set("is_matchme", true);
                }
                const path = t('baseurl') == "" ? "/" : t('baseurl')
                router.push({ path: unref(redirect) || path });
              })
              .catch((err) => {
                state.loading = false;
                state.loadingTxt = "";
                if(err.code == 301) {
                  showMsg.error(err.msg, {}, ()=>{
                    router.push({ path: `${t('baseurl')}/reg` });
                  });
                }else {
                  showMsg.error(err.msg);
                }
              }); 
         
        }
      })
    }, 500)

    return {
      ...toRefs(state),
      formRef,
      DoLogin
    };
  },
};
</script>

<style lang="less" scoped>
  .login-box .account-box .box {
    padding: 0 10px; 
    .text {
      line-height: 1.5;
    }
  }

  .tip {
    color: #666;
    margin-top: 20px;
  }
</style>
